(() => {
  const dismissalKey = 'ber-marketing-popup-dismissed';
  const subscribedKey = 'ber-marketing-popup-subscribed';

  function read(storage, key) {
    try { return storage.getItem(key) === '1'; } catch { return false; }
  }

  function write(storage, key) {
    try { storage.setItem(key, '1'); } catch { /* Storage can be unavailable in private browsing. */ }
  }

  function init(root) {
    root.querySelectorAll('[data-ber-popup]').forEach((container) => {
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';
      const dialog = container.querySelector('dialog');
      const close = container.querySelector('[data-ber-popup-close]');
      if (!dialog || !close || !dialog.showModal) return;

      const inEditor = Boolean(window.Shopify && window.Shopify.designMode);
      const success = Boolean(dialog.querySelector('.ber-popup__message'));
      const error = Boolean(dialog.querySelector('.ber-popup__error'));
      let timer;

      function open() { if (!dialog.open) dialog.showModal(); }
      function dismiss() { write(sessionStorage, dismissalKey); dialog.close(); }

      close.addEventListener('click', dismiss);
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dismiss(); });
      dialog.addEventListener('close', () => {
        if (!success && !inEditor) write(sessionStorage, dismissalKey);
      });

      if (success) {
        write(localStorage, subscribedKey);
        open();
      } else if (error) {
        open();
      } else if (!inEditor && !read(sessionStorage, dismissalKey) && !read(localStorage, subscribedKey)) {
        timer = window.setTimeout(open, Number(container.dataset.delay) || 6000);
      }

      if (inEditor) {
        const section = container.closest('.shopify-section');
        section?.addEventListener('shopify:section:select', () => { clearTimeout(timer); open(); });
        section?.addEventListener('shopify:section:deselect', () => dialog.close());
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
